"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storable_realtime_subscriptions_1 = __importDefault(require("../../Data/storable-realtime-subscriptions"));
var Tasks_consts_1 = require("../Tasks.consts");
var TaskRealtimeSubscriptions = /** @class */ (function () {
    function TaskRealtimeSubscriptions(session, tasksStore, storableDataService) {
        this.tasksStore = tasksStore;
        this.storableRealtimeSubscriptions = new storable_realtime_subscriptions_1.default(session, tasksStore, storableDataService);
    }
    TaskRealtimeSubscriptions.prototype.updateStoreOnEvents = function () {
        var _this = this;
        var events = [
            {
                name: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                isDelete: false,
                extraDataFunc: function (task) {
                    var isPartialUpdate = !task.hasOwnProperty('status');
                    return { ignore: isPartialUpdate && !_this.tasksStore.get(task.id) };
                }
            },
            { name: Tasks_consts_1.TaskRealTimeEvents.NEW_TASK, isDelete: false },
            { name: Tasks_consts_1.TaskRealTimeEvents.TASK_DELETED, isDelete: true }
        ];
        var subEntityEvents = [
            {
                name: Tasks_consts_1.TaskRealTimeEvents.NEW_SCAN,
                eventToRaise: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                parentField: 'task_id',
                field: 'scans',
                ignoreFields: ['way_points'],
                isDelete: false
            },
            {
                name: Tasks_consts_1.TaskRealTimeEvents.NEW_NOTE,
                eventToRaise: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                parentField: 'task_id',
                field: 'task_notes',
                ignoreFields: ['way_points'],
                isDelete: false
            },
            {
                name: Tasks_consts_1.TaskRealTimeEvents.WAYPOINT_ADDED,
                eventToRaise: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                parentField: 'task_id',
                field: 'way_points',
                ignoreFields: ['way_points'],
                isDelete: false
            },
            {
                name: Tasks_consts_1.TaskRealTimeEvents.WAYPOINT_UPDATED,
                eventToRaise: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                parentField: 'task_id',
                field: 'way_points',
                ignoreFields: ['way_points'],
                isDelete: false
            },
            {
                name: Tasks_consts_1.TaskRealTimeEvents.WAYPOINT_DELETED,
                eventToRaise: Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE,
                idField: 'way_point_id',
                parentField: 'task_id',
                field: 'way_points',
                ignoreFields: ['way_points'],
                isDelete: true
            }
        ];
        this.storableRealtimeSubscriptions.updateStoreOnEvents(events, subEntityEvents);
    };
    TaskRealtimeSubscriptions.prototype.onCreate = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Tasks_consts_1.TaskRealTimeEvents.NEW_TASK, callback);
    };
    TaskRealtimeSubscriptions.prototype.onDelete = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Tasks_consts_1.TaskRealTimeEvents.TASK_DELETED, callback);
    };
    TaskRealtimeSubscriptions.prototype.onWayPointUpdate = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Tasks_consts_1.TaskRealTimeEvents.WAYPOINT_UPDATED, callback);
    };
    TaskRealtimeSubscriptions.prototype.onWayPointDelete = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Tasks_consts_1.TaskRealTimeEvents.WAYPOINT_DELETED, callback);
    };
    TaskRealtimeSubscriptions.prototype.onUpdate = function (callback) {
        return this.storableRealtimeSubscriptions.onEvent(Tasks_consts_1.TaskRealTimeEvents.TASK_UPDATE, callback);
    };
    return TaskRealtimeSubscriptions;
}());
exports.default = TaskRealtimeSubscriptions;
//# sourceMappingURL=task-realtime-subscriptions.js.map